/*globals location:false*/
window.Popper = require('popper.js').default;
import $ from 'jquery';
window.$ = window.jQuery = $;

require('bootstrap');
require('bootstrap-datepicker');
require('balloon-css');
require('gritter/js/jquery.gritter');
import iziToast from "izitoast";
import SessionExpire from './session-expire';
require('./labcoat');
require('./focus');
require('./mobile');
require('./navigation');
require('./error');
require('./delete');
require('./subcontent');
require('./modals');
require('./impersonate');
require('@fortawesome/fontawesome-free/js/all');
require('@fortawesome/fontawesome-free/js/v4-shims');

window.iziToast = iziToast;

let session_expire = new SessionExpire();
window.resetIdleCountdown = function(){
    session_expire.resetIdleTimer();
}

